//  *** SLIDERS SETTING ANIMATION ***
const swiper = new Swiper(".swiper", {
  speed: 400,
  spaceBetween: 100,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
const swiperBuisness = new Swiper(".swiper-buisness", {
  autoplay: {
    delay: 5000,
  },
  speed: 400,
  spaceBetween: 100,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

const swiperLeasing = new Swiper(".leasing-swiper", {
  slidesPerView: 3,
  spaceBetween: 32,
  navigation: {
    nextEl: ".leasing-next",
    prevEl: ".leasing-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.2,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".leasing-next",
        prevEl: ".leasing-prev",
      },
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  },
});

const swiperNews = new Swiper(".news-swiper", {
  slidesPerView: 3,
  spaceBetween: 32,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  // centerInsufficientSlides: true,
  // centeredSlides: true,
  watchOverflow: true,
  navigation: {
    nextEl: ".news-next",
    prevEl: ".news-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: "auto",
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    768: {
      slidesPerView: 2.2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".news-next",
        prevEl: ".news-prev",
      },
      
    },
    1280: {
      spaceBetween: 32,
    },
  },
});

const advantageSlider = new Swiper(".advantage-swiper", {
  slidesPerView: 3.2,
  spaceBetween: 32,
  navigation: {
    nextEl: ".advantage-next",
    prevEl: ".advantage-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.3,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".advantage-next",
        prevEl: ".advantage-prev",
      },
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 32,
    },
  },
});

const newsContentSlider = new Swiper(".newsContent-swiper", {
  slidesPerView: 2,
  spaceBetween: 32,
  navigation: {
    nextEl: ".product-next",
    prevEl: ".product-prev",
  },
  breakpoints: {
    360: {
      slidesPerView: 1.12,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".product-next",
        prevEl: ".product-prev",
      },
    },
    1280: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
  },
});

const productSlider = new Swiper(".product-swiper", {
  slidesPerView: 3,
  spaceBetween: 32,
  navigation: {
    nextEl: ".product-next",
    prevEl: ".product-prev",
  },
  breakpoints: {
    360: {
      slidesPerView: 1.12,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".product-next",
        prevEl: ".product-prev",
      },
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 32,
    },
  },
});

const advantageCardsSlider = new Swiper(".about-page-partners__carousel", {
  spaceBetween: 32,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
  navigation: {
    nextEl: ".leasing-next",
    prevEl: ".leasing-prev",
  },

  breakpoints: {
    360: {
      slidesPerView: 1.3,
      spaceBetween: 8,
    },
    500: {
      slidesPerView: 1.8,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 3.25,
      spaceBetween: 20,
    },
    1280: {
      slidesPerView: 4,
      spaceBetween: 32,
    },
  },
});

const swiperPromotion = new Swiper(".promotion-swiper", {
  navigation: {
    nextEl: ".promotion-next",
    prevEl: ".promotion-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.2,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".promotion-next",
        prevEl: ".promotion-prev",
      },
    },
    1280: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
  },
});
const swiperPromotionStep = new Swiper(".promotion-step__slider", {
  navigation: {
    nextEl: ".promotion-step-next",
    prevEl: ".promotion-step-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.2,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },

    425: {
      slidesPerView: 1.35,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".promotion-step-next",
        prevEl: ".promotion-step-prev",
      },
    },

    1024: {
      slidesPerView: 3.2,
      spaceBetween: 32,
    },
    1280: {
      slidesPerView: 3.55,
      spaceBetween: 32,
    },
  },
});
const catalogOffersSlider = new Swiper(".catalog-offers-slider", {
  slidesPerView: 3,
  spaceBetween: 32,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,

  navigation: {
    nextEl: ".news-next",
    prevEl: ".news-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.135,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },

    },
    400: {
      slidesPerView: 1.5,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },

    },
    500: {
      slidesPerView: 1.8,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },

    },
    768: {
      slidesPerView: 2.2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".news-next",
        prevEl: ".news-prev",
      },
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 32,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    },
  },
});

const catalogImgSlider = new Swiper(".catalog-img-swiper", {
  slidesPerView: 1.74,
  spaceBetween: 6,
  centeredSlides: true,
  navigation: {
    nextEl: ".leasing-next",
    prevEl: ".leasing-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.04,
      spaceBetween: 6,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    400: {
      slidesPerView: 1.15,
      spaceBetween: 6,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    500: {
      slidesPerView: 1.5,
      spaceBetween: 6,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    768: {
      slidesPerView: 1.05,
      spaceBetween: 6,
      navigation: {
        nextEl: ".leasing-next",
        prevEl: ".leasing-prev",
      },
    },
    1000: {
      slidesPerView: 1.3,
      spaceBetween: 6,
      navigation: {
        nextEl: ".leasing-next",
        prevEl: ".leasing-prev",
      },
    },
    1280: {
      slidesPerView: 1.74,
      spaceBetween: 6,
    },
  },
});

const catalogBrandSwiper = new Swiper(".brand-swiper", {
  navigation: {
    nextEl: ".promotion-next",
    prevEl: ".promotion-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.12,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    400: {
      slidesPerView: 1.25,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    450: {
      slidesPerView: 1.5,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    500: {
      slidesPerView: 1.7,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    600: {
      slidesPerView: 1.95,
      spaceBetween: 8,
      navigation: {
        nextEl: null,
        prevEl: null,
      },
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
      navigation: {
        nextEl: ".promotion-next",
        prevEl: ".promotion-prev",
      },
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 32,
    },
  },
});
//  *** END SLIDERS SETTING ANIMATION ***